import React from "react";

const Title = ({ text }) => {
    return <h2 className="text-primary text-center my-4">{text}</h2>;
};

export default Title;
